module.exports = {
	"AlsoToday": "Auch heute",
	"Archive": "Archiv",
	"ClickHereForMoreInfo": "Klicken Sie hier für mehr Info",
	"ClientWebServiceNotResponding": "Der Service zur Authentifizierung ist derzeit nicht verfügbar",
	"Confirm": "Bestätigen",
	"Digital": "Digitale",
	"DigitalVersion": "Digitale",
	"Edition": "Ausgabe",
	"Help": "Hilfe",
	"HorsSeries": "Sonderprodukte",
	"LoadingNewspaperPleaseWait": "Zeitung lädt, bitte warten",
	"LogIn": "Einloggen",
	"LogInWith": "Einloggen mit:",
	"MaximumDeviceNumberReached": "Sie haben die maximal erlaubte Zahl an Geräten für diese Publikation erreicht.",
	"ModernBrowserRequired": "Um die digitale Zeitungsausgabe zu lesen, benötigen Sie Internet Explorer 9 oder höher. Wir raten Ihnen Ihren Browser zu aktualisieren oder einen anderen Browser herunterzuladen (Chrome, Firefox, …)",
	"More": "Mehr",
	"NewspaperCurrentlyUnavailable": "Die Zeitung kann momentan nicht geöffnet werden. Bitte versuchen Sie es später noch einmal.",
	"NoDigitalAccess": "Sie haben keinen digitalen Zugang",
	"OK": "OK",
	"Paper": "Papieren",
	"PaperVersion": "Papieren",
	"Password": "Passwort",
	"PleaseFillInAllFields": "Bitte füllen Sie alle Felder aus",
	"Promospot": "Promospot",
	"ReadingPreference": "Lesepräferenz",
	"Read": "Lesen",
	"ReadTheNewspaper": "Lies die Zeitung",
	"SelectEdition": "Wählen Sie eine Ausgabe",
	"SignIn": "Anmelden",
	"SignOut": "Abmelden",
	"SSOValidationFailed": "Die automatische Authentifizierung ist fehlgeschlagen.",
	"TemporarilyUnavailable": "Derzeit nicht verfügbar",
	"TheUsernameAndOrPasswordIsIncorrect": "Der Benutzername und/oder das Passwort sind nicht korrekt",
	"UnknownError": "Ein unerwarteter Fehler ist aufgetreten",
	"UnknownUser": "Der Benutzername ist nicht korrekt",
	"Username": "Benutzername / E-Mail-Adresse",
	"ValidationFailed": "Der Authentifizierungsservice ist derzeit nicht verfügbar.",
	"YourSessionHasExpired": "Ihre Sitzung ist abgelaufen",
	"downloadPDFerror": "Sie haben Ihr Downloadlimit für diese Ausgabe erreicht.",
	"Proceed": "Weiter",
	"ForgotPassword": "Passwort vergessen",
	"Cancel": "Abbrechen",
	"moment": "de",
	"Extra": "Sonderprodukte",
	"ChooseRegion": "Bitte wählen Sie eine Region",
	"downloadingNewsPaper": "Ihre Zeitung lädt, bitte haben Sie Geduld.",
	"CookieConfirmButton": "OK",
	"CookieLinkText": "Mehr Informationen",
	"CookieInformText": "Diese Webseite verwendet Cookies. Durch die Nutzung dieser Website erklären Sie sich mit der Verwendung von Cookies einverstanden. ",
	"home": "Home",
	"recently": "Aktuellste Ausgaben",
	"supplements": "Beilagen",
	"extras": "Sonderprodukte",
	"inforAndExtras": "Infos und Extras",
	"regions": "Regionen",
	"settings": {
		"title": "Einstellungen",
		"voucher": {
			"title": "Gutscheincode",
			"inactive": "Inaktiv",
			"active": "Aktiv bis",
			"instructions": "Geben Sie unten Ihren Gutschein ein, um Ihren temporären Zugang zu aktivieren.",
			"placeholder": "Geben Sie hier Ihren Gutschein ein",
			"validate": "Meinen Gutschein einlösen",
			"errors": {
				"expired": "Ihr Gutschein ist abgelaufen. Bitte kontaktieren Sie unseren Kundenservice.",
				"invalid": "Ihr Gutschein ist nicht gültig. Bitte geben Sie einen gültigen Gutschein ein oder kontaktieren Sie unseren Kundenservice, falls das Problem weiterhin besteht.",
				"alreadyRedeemed": "Ihr Gutschein ist bereits eingelöst. Bitte geben Sie einen gültigen Gutschein ein oder kontaktieren Sie den Kundenservice, falls das Problem weiterhin besteht.",
				"generic": "Es ist ein Fehler aufgetreten. Bitte geben Sie einen gültigen Gutschein ein oder kontaktieren Sie den Kundenservice, falls das Problem weiterhin besteht."
			}
		}
	},
	"sharingLandingBanner": {
		"text": "Hat Ihnen dieser Artikel gefallen? Melden Sie sich noch heute an, um mehr zu erfahren, oder loggen Sie sich ein, wenn Sie bereits Mitglied sind!",
		"signup": "Registrieren",
		"login": "Einloggen"
	},
	"region": "Region",
	"login": "Anmelden",
	"logout": "Abmelden",
	"help": "Hilfe",
	"about": "Über",
	"disclaimer": "Impressum und Datenschutz",
	"account": "Nutzer",
	"accountLoggedIn": "Angemeldet",
	"accountLoggedInInfo": "Sie sind derzeit angemeldet.",
	"accountLoggedWithInfo": "Sie sind derzeit angemeldet",
	"accountLoggedOut": "Nicht angemeldet",
	"version": "Version",
	"platformversion": "Plattform Version",
	"uuid": "UUID",
	"editor": "Verlag",
	"developer": "Entwickler",
	"downloading": "Lädt...",
	"journal": "Zeitung",
	"alsoRead": "Lesen Sie auch",
	"alsoWatch": "Sehen Sie auch",
	"alsoSee": "Siehe auch",
	"authorising": "Autorisieren...",
	"notSupported": "Diese Seite kann nur in aktuellen Browsern dargestellt werden. Bitte aktualisieren Sie Ihren Browser oder laden Sie Chrome.",
	"printImage": "Bild",
	"printText": "Text",
	"print": "Drucken",
	"jumpBack": "Back",
	"download": "der Download",
	"fullPdfDownload": "Ganze Ausgabe",
	"pagePdfDownload": "Aktuelle Seite",
	"pdfDownloadTooltip": "Download",
	"logoTooltip": "Zurück zum Kiosk",
	"readerLogoTooltip": "Zurück zum Kiosk",
	"landscapeToggle": "Lesen im Querformat",
	"singlePage": "Einzelseitenansicht",
	"singlePageShort": "Einzelseite",
	"doublePage": "Doppelseitenansicht",
	"doublePageShort": "Doppelseite",
	"passwordForgottenLoadingText": "Bitte warten Sie während die Seite lädt",
	"landscapeToggleEExplanation": "Wenn Sie im Querformat lesen, können Sie wählen, ob Sie eine Seite in voller Seitenbreite oder eine Doppelseite angezeigt haben möchten.",
	"PleaseFillInAValidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
	"LeftPage": "Linke Seite",
	"RightPage": "Rechte Seite",
	"Sorry": "Entschuldigung!",
	"close": "Schließen",
	"printLeftPage": "Linke Seite",
	"printRightPage": "Rechte Seite",
	"printSinglePage": "Aktuelle Seite",
	"cropPrint": "Drucken",
	"cropPrintInstruction": "Um die ganze Seite zu drucken, klicken Sie auf \"Drucken\".<br>Um einen Teil einer Seite oder eines bestimmten Artikels zu drucken, ändern Sie die Größe des blauen Rahmens, indem Sie auf die Ecken klicken und sie ziehen und sie um den Teil der Seite platzieren, den Sie drucken möchten.",
	"cropPrintTitle": "Drucken",
	"openCMPSetting": "Meine Datenschutzeinstellungen",
	"dataPolicy": "Persönliche Daten",
	"privacyPolicy": "Hinweise zum Datenschutz",
	"singlePageMode": "Einzelseitenansicht",
	"doublePageMode": "Doppelseitenansicht",
	"readingModeToggle": "Lesemodus",
	"E1": "Die Systeme sind nicht verfügbar. Bitte versuchen Sie es später erneut.",
	"E2": "Systeme sind nicht verfügbar. Bitte versuchen Sie es später erneut.",
	"E3": "Der Authentifizierungsservice ist derzeit nicht verfügbar",
	"E4": "Die Systeme sind nicht verfügbar. Bitte versuchen Sie es später erneut.",
	"E5": "Sie haben kein gültiges Abonnement; bitte überprüfen Sie Ihre Abodaten oder kontaktieren Sie unseren Kundenservice.\r\r\n\r\r\n",
	"E6": "Ungültige Anmeldedaten. Überprüfen Sie Ihre E-Mail / Ihr Passwort und versuchen Sie es erneut",
	"E7": "Ungültige Anmeldedaten. Überprüfen Sie Ihre E-Mail / Ihr Passwort und versuchen Sie es erneut",
	"E8": "Die Zeitung kann momentan nicht geöffnet werden. Bitte versuchen Sie es später noch einmal.",
	"E9": "Die Systeme sind nicht verfügbar. Bitte versuchen Sie es später erneut.",
	"E11": "Sie haben mit Ihrem Abonnement die maximale Anzahl von Downloads erreicht",
	"E13": "Die Systeme sind nicht verfügbar. Bitte versuchen Sie es später erneut.",
	"E15": "Die Systeme sind nicht verfügbar. Bitte versuchen Sie es später erneut.",
	"E16": "",
	"E17": "Der Authentifizierungsservice ist derzeit nicht verfügbar",
	"E18": "Der Authentifizierungsservice ist derzeit nicht verfügbar",
	"E20": "Der Authentifizierungsservice ist derzeit nicht verfügbar",
	"E21": "Der Authentifizierungsservice ist derzeit nicht verfügbar",
	"E24": "Ihr Abonnement verfügt nicht über ausreichende Rechte zum Lesen der Veröffentlichung",
	"E25": "Maximale Anzahl gleichzeitiger Sitzungen, die für die Abonnementreferenz erreicht wurden",
	"E26": "Diese Anmeldedaten können nicht überprüft werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Kundenservice.",
	"pageDoesNotExist": "Diese Seite ist nicht verfügbar",
	"returnToKiosk": "Zurück zur Zeitung",
	"error404": "Fehler 404"
};


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/de_de.json
// module id = 457
// module chunks = 0 1